import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import { boolean, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { accounts } from './accounts';
import { sessions } from './sessions';

export const userRoleEnum = pgEnum('user_role', ['user', 'admin']);
export type UserRole = (typeof userRoleEnum.enumValues)[number];

export const userRoleOptions: Array<{ value: UserRole; label: string }> = [
  {
    value: 'user',
    label: 'Padrão',
  },
  {
    value: 'admin',
    label: 'Administrador',
  },
];

export const users = pgTable('users', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  name: text('name').notNull(),
  email: text('email').notNull().unique(),
  emailVerified: boolean('email_verified').default(false).notNull(),
  image: text('image'),
  role: userRoleEnum('role').notNull().default('user'),
  isActive: boolean('is_active').default(true),
  // Ligado quando um admin reseta a senha de outro usuário (senha temporária) — força a
  // troca no próximo login, antes de liberar o resto do app.
  needToChangePassword: boolean('need_to_change_password').notNull().default(false),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const usersRelations = relations(users, ({ many }) => ({
  sessions: many(sessions),
  accounts: many(accounts),
}));

export type User = InferSelectModel<typeof users>;
export type CreateUserInput = InferInsertModel<typeof users>;
export type UpdateUserInput = Partial<CreateUserInput>;
